/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scim_Enabled_SuccessInputs */



/**
* | output |
* | --- |
* | "SCIM provisioning enabled successfully" |
*
* @param {Scim_Enabled_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const scim_enabled_success = /** @type {((inputs?: Scim_Enabled_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scim_Enabled_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("SCIM-Bereitstellung erfolgreich aktiviert")
	return /** @type {LocalizedString} */ ("SCIM provisioning enabled successfully")
});